<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="观看数" prop="lookNum" >-->
      <!--        <a-input v-model="form.lookNum" placeholder="请输入观看数" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="剧名" prop="videoName">
        <a-input show-count v-model="form.videoName" placeholder="请输入剧名" />
      </a-form-model-item>


      <a-form-model-item label="英文剧名" prop="videoNameEn">
        <a-input show-count v-model="form.videoNameEn" placeholder="请输入英文剧名" />
      </a-form-model-item>

      <a-form-model-item label="日语剧名" prop="videoNameJa">
        <a-input show-count v-model="form.videoNameJa" placeholder="请输入日语剧名" />
      </a-form-model-item>

      <a-form-model-item label="印尼剧名" prop="videoNameId">
        <a-input show-count v-model="form.videoNameId" placeholder="请输入印尼剧名" />
      </a-form-model-item>

      <a-form-model-item label="葡语剧名" prop="videoNamePt">
        <a-input show-count v-model="form.videoNamePt" placeholder="请输入葡语剧名" />
      </a-form-model-item>

      <a-form-model-item label="西语剧名" prop="videoNameEs">
        <a-input show-count v-model="form.videoNameEs" placeholder="请输入西语剧名" />
      </a-form-model-item>

      <a-form-model-item label="封面图" prop="coverUrl">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrl" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload"
          :customRequest="handleChange">
          <plus-outlined />
          <img v-if="form.coverUrl" :src="form.coverUrl" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="英文封面图" prop="coverUrlEn">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlEn" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload1"
          :customRequest="handleChange1">
          <plus-outlined />
          <img v-if="form.coverUrlEn" :src="form.coverUrlEn" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="日语封面图" prop="coverUrlJa">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlJa" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload2"
          :customRequest="handleChange2">
          <plus-outlined />
          <img v-if="form.coverUrlJa" :src="form.coverUrlJa" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading2 ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="印尼封面图" prop="coverUrlId">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlId" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload3"
          :customRequest="handleChange3">
          <plus-outlined />
          <img v-if="form.coverUrlId" :src="form.coverUrlId" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading3 ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="葡语封面图" prop="coverUrlPt">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlPt" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload4"
          :customRequest="handleChange4">
          <plus-outlined />
          <img v-if="form.coverUrlPt" :src="form.coverUrlPt" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading4 ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="西语封面图" prop="coverUrlEs">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlEs" :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload5"
          :customRequest="handleChange5">
          <plus-outlined />
          <img v-if="form.coverUrlEs" :src="form.coverUrlEs" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading5 ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="短剧类型" prop="videoType">
        <a-select placeholder="请选择短剧类型" v-model="form.videoType">
          <a-select-option :value="1">普通剧</a-select-option>
          <a-select-option :value="2">互动剧</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="总集数" prop="totalNum"
        :rules="form.videoType == 0 ? [{ required: true, message: '总集数不能为空' }] : []">
        <a-input v-model="form.totalNum" />
      </a-form-model-item>

      <a-form-model-item label="观看数" prop="fakeLookNum">
        <a-input-number :min="1" v-model="form.fakeLookNum" placeholder="请输入假观看数" />
      </a-form-model-item>

      <a-form-model-item label="收藏数" prop="fakeCollectNum">
        <a-input-number :min="1" v-model="form.fakeCollectNum" placeholder="请输入假收藏数" />
      </a-form-model-item>

      <a-form-model-item label="订阅数" prop="subscribeNum">
        <a-input-number :min="1" v-model="form.subscribeNum" placeholder="请输入假订阅数" />
      </a-form-model-item>
      <a-form-model-item label="商品ID" prop="productId">
        <a-input v-model="form.productId" placeholder="请输入商品ID" style="width: 200px;" />
      </a-form-model-item>
      <a-form-model-item label="是否只允许全集解锁" prop="onlyFullUnlock">
        <a-switch v-model="form.onlyFullUnlock" :checked-children="是" :un-checked-children="否"
          @change="val => form.onlyFullUnlock = val ? 1 : 0" />
      </a-form-model-item>

      <a-form-model-item label="优惠比例" prop="promotionRate">
        <a-input-number :min="1" v-model="form.promotionRate" placeholder="请输入优惠比例" />
      </a-form-model-item>


      <a-form-model-item v-if="videoProduct" label="商品信息">
        <div>
          <p><strong>商品备注：</strong>{{ videoProduct.remark }}</p>
          <p><strong>商品价格：</strong>{{ videoProduct.price }}</p>
        </div>
      </a-form-model-item>
      <!--      <a-form-model-item label="标签" prop="type" >-->
      <!--        <a-select placeholder="请选择标签"  v-model="form.type">-->
      <!--          <a-select-option :key="0">无</a-select-option>-->
      <!--          <a-select-option :key="1">NEW</a-select-option>-->
      <!--          <a-select-option :key="2">Hot</a-select-option>-->
      <!--          <a-select-option :key="3">首播</a-select-option>-->
      <!--          <a-select-option :key="4">独播</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->


      <a-form-model-item label="是否上映" prop="isRelease">
        <a-select placeholder="请选择是否上映" @change="updateIsGo" v-model="form.isRelease">
          <a-select-option :key="0">否</a-select-option>
          <a-select-option :key="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.isGo == '0'" label="上映时间" prop="releaseTime">
        <a-date-picker show-time :allow-clear="true" size="default" v-model="form.releaseTime" placeholder="请选择上映时间"
          value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" :show-time="{ format: 'HH:mm' }">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="分类" prop="tagIds">
        <!--        <a-input v-model="form.tagIds" placeholder="请输入标签ids" />-->
        <a-tree-select v-model="tagIds" style="width: 100%" :tree-data="treeData" tree-checkable
          search-placeholder="请选择分类" @change="changeSelect" />
      </a-form-model-item>
      <!--      <a-form-model-item label="前多少集可以使用金币观看" prop="limitNum" >-->
      <!--        <a-input-number :min="0" v-model="form.limitNum" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="免费观看集数" prop="freeLimitNum"
        :rules="form.videoType == 0 ? [{ required: true, message: '前多少集可以免费观看不能为空' }] : []">
        <a-input v-model="form.freeLimitNum" />
      </a-form-model-item>
      <a-form-model-item label="每集金币价格" prop="diamondPrice">
        <a-input-number :min="0" v-model="form.diamondPrice" placeholder="请输入" />
      </a-form-model-item>
      <!--      <a-form-model-item label="每集金币价格" prop="goldPrice" >-->
      <!--        <a-input-number :min="0" v-model="form.goldPrice" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="简介" prop="introductions">
        <a-textarea show-count :maxLength='500' v-model="form.introductions" placeholder="请输入简介" />
      </a-form-model-item>

      <a-form-model-item label="英文简介" prop="introductionsEn">
        <a-textarea show-count :maxLength='500' v-model="form.introductionsEn" placeholder="请输入英文简介" />
      </a-form-model-item>
      <a-form-model-item label="日语简介" prop="introductionsJa">
        <a-textarea show-count :maxLength='500' v-model="form.introductionsJa" placeholder="请输入日语简介" />
      </a-form-model-item>

      <a-form-model-item label="印尼简介" prop="introductionsId">
        <a-textarea show-count :maxLength='500' v-model="form.introductionsId" placeholder="请输入印尼简介" />
      </a-form-model-item>

      <a-form-model-item label="葡语简介" prop="introductionsPt">
        <a-textarea show-count :maxLength='500' v-model="form.introductionsPt" placeholder="请输入葡语简介" />
      </a-form-model-item>
      <a-form-model-item label="西语简介" prop="introductionsEs">
        <a-textarea show-count :maxLength='500' v-model="form.introductionsEs" placeholder="请输入西语简介" />
      </a-form-model-item>
      <a-form-model-item label="每集金币划线价格" prop="underlinedPrice">
        <a-input-number :min="0" v-model="form.underlinedPrice" placeholder="请输入" />
      </a-form-model-item>

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/video'
import { listTag } from '@/api/video/tag'
import UploadFileToVOD from "@/api/vod.js"
import { uploadCos } from '@/api/common/index'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      isGo: false,
      tagIds: [],
      videoProduct: null,
      // 表单参数
      form: {
        id: null,

        fakeLookNum: null,

        fakeCollectNum: null,

        subscribeNum: null,

        collectNum: null,

        limitNum: null,

        diamondPrice: null,
        underlinedPrice: null,

        goldPrice: null,

        introductions: null,
        introductionsEn: null,
        introductionsJa: null,
        tagIds: null,

        totalNum: null,
        releaseTime: null,
        videoName: null,
        videoNameEn: null,
        videoNameJa: null,
        coverUrl: null,
        coverUrlEn: null,
        coverUrlJa: null,

        videoNameId: null,
        videoNamePt: null,
        videoNameEs: null,
        coverUrlId: null,
        coverUrlPt: null,
        videoType: null,
        coverUrlEs: null,
        introductionsId: null,
        introductionsPt: null,
        introductionsEs: null,
        productId: null,
        onlyFullUnlock: null,
        promotionRate: null,

        createTime: null,
        freeLimitNum: null,
        remark: null,
        isRelease: 1
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false,
      uploadLoading1: false,
      uploadLoading2: false,
      uploadLoading3: false,
      uploadLoading4: false,
      uploadLoading5: false,
      treeData: [],
      rules: {
        lookNum: [
          { required: true, message: '观看数不能为空' }
        ],
        collectNum: [
          { required: true, message: '收藏数不能为空' }
        ],
        limitNum: [
          { required: true, message: '前多少集可以使用金币观看不能为空' }
        ],
        freeLimitNum: [
          { required: true, message: '前多少集可以免费观看不能为空' }
        ],
        tagIds: [
          { required: true, message: '标签不能为空' }
        ],
        totalNum: [
          { required: true, message: '总集数不能为空' }
        ],
        releaseTime: [
          { required: true, message: '请选择上映时间' }
        ],
        videoName: [
          { required: true, message: '剧名不能为空' },

        ],
        videoNameEn: [
          { required: true, message: '英文剧名不能为空' },

        ],
        introductions: [
          { max: 500, message: '简介最多500字' }
        ],
        introductionsEn: [
          { max: 500, message: '简介最多500字' }
        ],
        coverUrl: [
          { required: true, message: '封面图不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created() {

  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getAllList();
  },
  methods: {
    updateIsGo(value) {
      this.isGo = value
    },
    handleChange(info) {

      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },

      });
      that.uploadLoading = false;

    },
    handleChange1(info) {

      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlEn = fileName[0];//文件名
          that.uploadLoading1 = false;
        },

      });

    },
    handleChange2(info) {

      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlJa = fileName[0];//文件名
          that.uploadLoading2 = false;
        },

      });

    },

    handleChange3(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlId = fileName[0];//文件名
          that.uploadLoading3 = false;
        },
      });

    },
    handleChange4(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlPt = fileName[0];//文件名
          that.uploadLoading4 = false;
        },
      });

    },
    handleChange5(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaa" + fileName[0])
          that.form.coverUrlEs = fileName[0];//文件名
          that.uploadLoading5 = false;
        },
      });

    },

    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      this.form.coverUrl = ""
      //TODO 驗證文件大小
    },
    beforeUpload1: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading1 = false
        return false;
      }
      this.form.coverUrlEn = ""
      //TODO 驗證文件大小
    },
    beforeUpload2: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading2 = false
        return false;
      }
      this.form.coverUrlJa = ""
      //TODO 驗證文件大小
    },


    beforeUpload3: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading3 = false
        return false;
      }
      this.form.coverUrlId = ""
      //TODO 驗證文件大小
    },
    beforeUpload4: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading4 = false
        return false;
      }
      this.form.coverUrlPt = ""
      //TODO 驗證文件大小
    },
    beforeUpload5: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading5 = false
        return false;
      }
      this.form.coverUrlEs = ""
      //TODO 驗證文件大小
    },
    handleUpload(info) { //上传主图(一张图)
      console.log(info)
      let that = this;
      this.form.coverUrl = "";
      this.uploadLoading = true;
      uploadCos(info.file)
      //  , function (fileName) {
      //   console.log('--------------------------------')
      //   console.log(fileName)
      //   console.log('--------------------------------')
      //   that.uploadLoading = false;
      //   that.form.coverUrl = fileName;
      // }
    },
    changeSelect(e, label, extra) {
      this.tagIds = e;
      this.form.tagIds = e.join(',')
    },
    getAllList() {
      listTag().then(res => {
        console.log(res.data)
        this.treeData = res.data.map(i => ({
          title: i.tagTitle,
          value: i.id,
          key: i.id
        }))
      })
    },
    onClose() {
      this.tagIds = null
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        fakeLookNum: null,
        videoType: null,
        fakeCollectNum: null,
        subscribeNum: null,
        limitNum: null,
        diamondPrice: null,
        goldPrice: null,
        introductions: null,
        introductionsEn: null,
        introductionsJa: null,
        tagIds: [],
        totalNum: null,
        type: 0,
        videoName: null,
        videoNameEn: null,
        videoNameJa: null,
        coverUrl: null,
        coverUrlEn: null,
        coverUrlJa: null,
        createTime: null,
        remark: null,
        isRelease: 1,
        releaseTime: null,
        freeLimitNum: null,
        videoNameId: null,
        productId: null,
        onlyFullUnlock: null,
        promotionRate: null,
        videoNamePt: null,
        videoNameEs: null,
        coverUrlId: null,
        coverUrlPt: null,
        coverUrlEs: null,
        introductionsId: null,
        introductionsPt: null,
        introductionsEs: null
      }

      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.updateIsGo(0)
      this.isGo = 1
      // this.form={
      //   id: null,
      //
      //   lookNum: null,
      //
      //   limitNum: null,
      //
      //   diamondPrice: null,
      //
      //   goldPrice: null,
      //
      //   introductions: null,
      //   introductionsEn: null,
      //
      //   tagIds: null,
      //
      //   totalNum: null,
      //
      //   videoName: null,
      //   videoNameEn: null,
      //
      //   coverUrl: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //   isRelease:1
      // }
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({ "id": id }).then(response => {
        this.form = response.data
        this.isGo = response.data.isRelease
        if (response.data.tagIds) {
          this.tagIds = response.data.tagIds.split(',')
        } else {
          this.tagIds = null;
        }
        this.open = true
        this.formTitle = '修改'
        this.videoProduct = response.data.videoProduct || null
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVideo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
